export const defaultPageSize = 10;
export const defaultHeaders = { pageSize: defaultPageSize, pageNumber: 0 };
export const supportEmail = 'Old Glory Pay Mobile App';
export const currencyCode = '840';
export const tablePageSize = 10;
export const tableOffSet = 10;
export const defaultOffSet = 0;
export const merchantReportType = 'TODAY';
export const appName = 'Old-Glory';
export const font_Family = 'Scandia, sans-serif';
export const deviceIdKey = appName + '_dvc_id';
